//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import * as ActiveStorage from "@rails/activestorage"
import Uploader from "../../utils/uploader"; // import EventController, {
//   DISABLE_SUBMIT_BUTTON
// } from "../../utils/global-event-controller";
// ActiveStorage.start()

export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      uploaded: false,
      progress: {
        value: -1
      },
      fileTitle: null,
      fileImage: null,
      fileValue: null,
      inputElement: null,
      placeholder: {}
    };
  },
  computed: {
    showProgress: function showProgress() {
      return this.progress.value >= 0;
    }
  },
  methods: {
    $ready: function $ready() {
      if (Utils.type.isString(this.spec.value)) {
        this.uploaded = true;
        this.fileTitle = this.spec.fileTitle;
        this.fileImage = this.spec.fileUrl;
        this.fileValue = this.spec.value;
      }

      this.placeholder = this.spec.placeholderView || {};
      this.inputElement = this.$refs.directUploadFile;
    },
    triggerUpload: function triggerUpload() {
      this.inputElement.click();
    },
    removeImage: function removeImage() {
      this.uploaded = false;
      this.fileTitle = null;
      this.fileImage = null;
      this.fileValue = null;
    },
    displayImagePreview: function displayImagePreview(file, blob) {
      var _this = this;

      var reader = new FileReader();

      reader.onload = function (e) {
        _this.fileTitle = file.name;
        _this.fileImage = e.target.result;
        _this.fileValue = blob.signed_id;
      };

      reader.readAsDataURL(file);
    },
    uploadFile: function uploadFile(file) {
      var _this2 = this;

      var upload = new Uploader(file, this.spec.directUploadUrl, this.progress);
      var input = this.inputElement;

      if (upload.validateFile(this.spec)) {
        this.$dispatchEvent("forms/setBusy", {
          value: true
        }); // TODO: Delete
        // EventController.$emit(DISABLE_SUBMIT_BUTTON, true);

        input.disabled = true;
        upload.start(function (error, blob) {
          if (error) {
            Utils.launch.snackbar.error(error, _this2);
          } else {
            _this2.uploaded = true;
            _this2.progress.value = -1;

            _this2.displayImagePreview(file, blob);
          }

          input.disabled = false;
          input.value = null; // EventController.$emit(DISABLE_SUBMIT_BUTTON, false);

          _this2.$dispatchEvent("forms/setBusy", {
            value: false
          });
        });
      } else {
        input.value = null;
      }
    },
    uploadFiles: function uploadFiles(e) {
      var _this3 = this;

      Array.from(e.target.files).forEach(function (file) {
        return _this3.uploadFile(file);
      });
    } // toggleDisplayProgressIndicator() {
    //   this.showProgress = !this.showProgress
    // },
    // updateProgressIndicator(e) {
    //   this.valueProgress = e.detail.progress
    // }

  }
};